import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot } from "vue";
import { ContentLoader } from "vue-content-loader";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextContentLoading',
    props: {
        width: String,
        height: String,
        loading: Boolean,
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (__props.loading)
                ? (_openBlock(), _createBlock(_unref(ContentLoader), {
                    key: 0,
                    width: __props.width,
                    height: __props.height
                }, null, 8 /* PROPS */, ["width", "height"]))
                : _renderSlot(_ctx.$slots, "default", { key: 1 });
        };
    }
});
